import { useMutation } from '@apollo/client/react';
import { logError } from 'fergy-core-react-logging';
import { useCallback } from 'react';
import type { TrackClientMetricMutation, TrackClientMetricMutationVariables } from '../../__generated__/graphql-client-types';
import { TRACK_CLIENT_METRIC } from '../../queries/site-info/site-info.queries';

export const useTrackClientMetric = (): ((key: string, data?: any, metricValue?: number) => Promise<void>) => {
	const [trackClientMetric] = useMutation<TrackClientMetricMutation, TrackClientMetricMutationVariables>(TRACK_CLIENT_METRIC);

	return useCallback(
		async (key: string, data?: any, metricValue?: number) => {
			try {
				await trackClientMetric({ variables: { input: { key, data, metricValue } } });
			} catch (error) {
				logError(error, { message: 'Failed to track client metric' });
			}
		},
		[trackClientMetric]
	);
};
